module["exports"] = [
  "5##-###-###",
  "5##.###.###",
  "5## ### ###",
  "5########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/cell_phone/formats.js
// module id = 569
// module chunks = 0